import { h, empty } from '../../../../../src/shared/components/dom.js';
import { Spinner } from '../../../../../src/shared/components/spinner.js';
import { EmptyState } from '../../../../../src/shared/components/empty-state.js';
import { getPublicLists } from '../../api.js';

export async function render(_params, { root, isCurrent = () => true }) {
  empty(root);
  root.appendChild(Spinner({ label: 'Loading public lists…' }));

  let items;
  try {
    const data = await getPublicLists({ sort: 'top', window: '30d', limit: 50 });
    if (!isCurrent()) return false;
    items = data.lists || [];
  } catch {
    if (!isCurrent()) return false;
    empty(root);
    root.appendChild(EmptyState({
      title: 'Couldn’t load public lists',
      message: 'Try again in a moment.',
      action: h('a', { class: 'lib-btn', href: '/library' }, '← Back to library'),
      headingLevel: 'h1',
    }));
    return false;
  }

  empty(root);
  root.appendChild(buildScreen(items));
  return true;
}

function buildScreen(items) {
  const screen = h('section', { class: 'lib-lists-screen' });

  screen.appendChild(
    h('a', { class: 'lib-game-back', href: '/library' }, '← Library')
  );
  screen.appendChild(
    h('div', { class: 'lib-list-header' },
      h('h1', { class: 'lib-list-title' }, 'Public Lists'),
    )
  );

  if (!items.length) {
    screen.appendChild(
      h('div', { class: 'lib-list-empty' },
        h('p', null, 'No public lists yet.'),
        h('p', { class: 'lib-list-empty-hint' },
          'Public lists appear here once users share their curated collections.',
        ),
      )
    );
    return screen;
  }

  const grid = h('div', { class: 'lib-lists-grid' });
  for (const item of items) {
    grid.appendChild(renderPublicListCard(item));
  }
  screen.appendChild(grid);
  return screen;
}

function renderPublicListCard(item) {
  const curator = item.curator?.display_name || item.curator?.username || 'Unknown';
  return h('a', {
    class: 'lib-list-card',
    href: `/library/list/${item.id}`,
    'aria-label': `Open ${item.name}`,
  },
    h('h2', { class: 'lib-list-card-title' }, item.name),
    item.description
      ? h('p', { class: 'lib-list-card-description' }, truncate(item.description, 140))
      : null,
    h('div', { class: 'lib-list-card-meta' },
      h('span', null, `${item.item_count || 0} ${item.item_count === 1 ? 'game' : 'games'}`),
      h('span', { class: 'lib-list-card-curator' }, `by ${curator}`),
      h('span', { class: 'lib-list-card-likes' },
        h('span', { class: 'lib-list-card-heart' }, '♥'),
        ` ${item.like_count || 0}`,
      ),
    ),
  );
}

function truncate(s, max) {
  if (!s || s.length <= max) return s;
  return s.slice(0, max - 1) + '…';
}
